import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
// import SelectDropdown from "../../components-react/SelectDropdown";
// import { ScrollableComponentElement } from "scrollable-component";
import { BodyBuilder } from "../../../exports/Images";
import moment from "moment";
import { fetchPTTrainersData } from "../../../redux/reducers/apiSlice";
// import { monthsData } from "../../common-data/DropdowData";

const AllFeedbacks = ({
  decryptedText,
  allFeedbacks,
  setSelectedTrainer,
  queryParametersForAll,
  gymFeedbackFilter,
}) => {
  // const { loading, error } = useSelector((state) => state.api);
  const dispatch = useDispatch();
  const { allPTTrainersData } = useSelector((state) => state.api);
  // const isAdmin = decryptedText?.account_type === "admin";
  const [trainersData, setAllTrainersData] = useState([]);

  const getParameterValue = (parameterName, queryString) => {
    const regex = new RegExp(`[?&]${parameterName}=([^&]*)`);
    const match = regex.exec(queryString);
    return match ? decodeURIComponent(match[1]) : null;
  };
  const selectedGymValue = getParameterValue("gym_id", queryParametersForAll);
  const gymID =
    decryptedText?.account_type !== "admin"
      ? decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
      : gymFeedbackFilter
      ? gymFeedbackFilter
      : selectedGymValue
      ? selectedGymValue
      : "";

  useEffect(() => {
    if (gymID) {
      dispatch(
        fetchPTTrainersData({
          gymId: gymID,
          token: decryptedText?.token,
        })
      );
    } else {
      dispatch(
        fetchPTTrainersData({
          gymId: "",
          token: decryptedText?.token,
        })
      );
    }
  }, [gymID]);

  useEffect(() => {
    if (allPTTrainersData?.status && allPTTrainersData?.data?.length > 0) {
      const trainers = allPTTrainersData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainersData(trainers);
    } else {
      setAllTrainersData([]);
    }
  }, [allPTTrainersData]);

  const formattedDate = (date) =>
    moment(parseInt(date) * 1000).tz("Asia/Kolkata").format("DD-MM-YYYY");

  return (
    <div className="formContainer allFeedbacks">
      {gymID ? (
        <div
          className="tabsPayoutsContainer allPtMemTabs"
          style={{
            padding: "0",
            width: "100%",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Tabs
            id="uncontrolled-payouts-tab"
            className="mb-3"
            onSelect={(selectedKey) => {
              const selectedTrainer = trainersData.find(
                (trainer) => trainer?.value === selectedKey
              );
              setSelectedTrainer(selectedTrainer?.value);
            }}
          >
            <Tab eventKey="all" title="All">
              <scrollable-component className="my-content">
                <div className="allFeedbacksCard">
                  {allFeedbacks.allFeedbacksDatas?.map((feedback, index) => (
                    <div
                      className="feedbackCard"
                      key={index}
                      style={{ width: "100%" }}
                    >
                      <div className="nameRating">
                        <h4 className="name">
                          {feedback?.trainer_name || "NA"}
                        </h4>
                        <div className="ratingIcon">
                          <label htmlFor="rating" className="number">
                            {feedback?.rating || "-"}
                          </label>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-star-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                        </div>
                      </div>
                      <div className="contentBox">
                        <p className="content">
                          {feedback?.description || "No Description Available!"}
                        </p>
                      </div>
                      <div className="profileNameDate">
                        <div className="imgCont">
                          <img
                            src={feedback?.profile || BodyBuilder}
                            alt={feedback?.name || "NA"}
                          />
                        </div>
                        <div className="nameDate">
                          <p className="name">{feedback?.name || "NA"}</p>
                          <span className="date">
                            {formattedDate(feedback?.date_added) || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </scrollable-component>
            </Tab>
            {trainersData?.map((trainer, index) => (
              <Tab
                key={index}
                eventKey={trainer?.value || ""}
                title={trainer?.label || "NA"}
              >
                <scrollable-component className="my-content">
                  <div className="allFeedbacksCard">
                    {allFeedbacks.allFeedbacksDatas?.map((feedback, index) => (
                      <div
                        className="feedbackCard"
                        key={index}
                        style={{ width: "100%" }}
                      >
                        <div className="nameRating">
                          <h4 className="name">
                            {feedback?.trainer_name || "NA"}
                          </h4>
                          <div className="ratingIcon">
                            <label htmlFor="rating" className="number">
                              {feedback?.rating || "-"}
                            </label>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-star-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>
                          </div>
                        </div>
                        <div className="contentBox">
                          <p className="content">
                            {feedback?.description ||
                              "No Description Available!"}
                          </p>
                        </div>
                        <div className="profileNameDate">
                          <div className="imgCont">
                            <img
                              src={feedback?.profile || BodyBuilder}
                              alt={feedback?.name || "NA"}
                            />
                          </div>
                          <div className="nameDate">
                            <p className="name">{feedback?.name || "NA"}</p>
                            <span className="date">
                              {formattedDate(feedback?.date_added) || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </scrollable-component>
              </Tab>
            ))}
          </Tabs>
        </div>
      ) : (
        <scrollable-component className="my-content">
          <div className="allFeedbacksCard">
            {allFeedbacks.allFeedbacksDatas?.map((feedback, index) => (
              <div className="feedbackCard" key={index}>
                <div className="nameRating">
                  <h4 className="name">{feedback?.trainer_name || "NA"}</h4>
                  <div className="ratingIcon">
                    <label htmlFor="rating" className="number">
                      {feedback?.rating || "-"}
                    </label>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                  </div>
                </div>
                <div className="contentBox">
                  <p className="content">
                    {feedback?.description || "No Description Available!"}
                  </p>
                </div>
                <div className="profileNameDate">
                  <div className="imgCont">
                    <img
                      src={feedback?.profile || BodyBuilder}
                      alt={feedback?.name || "NA"}
                    />
                  </div>
                  <div className="nameDate">
                    <p className="name">{feedback?.name || "NA"}</p>
                    <span className="date">
                      {formattedDate(feedback?.date_added) || "-"}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </scrollable-component>
      )}
    </div>
  );
};

export default AllFeedbacks;
